import React from 'react';
import { Helmet, useHistory, generatePath, isBrowser } from '@ies/ace';
import { parsePathParams } from '@/utils';
import { LocalesList, Locale2RegionMap } from '@/constants/i18n';

const SEO = ({
  origin: _origin
}) => {
  var _a;

  const origin = !isBrowser() ? _origin : window.location.origin;
  const history = useHistory();
  const params = parsePathParams(history.location.pathname);

  if (!(params === null || params === void 0 ? void 0 : params.page) || !(params === null || params === void 0 ? void 0 : params.region)) {
    return null;
  }

  const prefix = `/${params.page}`;
  const suffix = (params === null || params === void 0 ? void 0 : params.paths) ? `/${(_a = params === null || params === void 0 ? void 0 : params.paths) === null || _a === void 0 ? void 0 : _a.join('/')}` : '';

  const generateUrl = (region = '') => {
    let path = '';

    if (!region) {
      path = prefix + suffix;
    } else {
      path = generatePath(`${prefix}/:region${suffix}`, {
        region
      });
    }

    return origin + path;
  };

  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: generateUrl(Locale2RegionMap[params === null || params === void 0 ? void 0 : params.region])
  }), /*#__PURE__*/React.createElement("link", {
    rel: "alternate",
    hrefLang: "x-default",
    href: generateUrl()
  }), LocalesList.map(lr => /*#__PURE__*/React.createElement("link", {
    key: lr,
    rel: "alternate",
    hrefLang: lr,
    href: generateUrl(Locale2RegionMap[lr])
  })));
};

export default SEO;